import { useNavigate } from "react-router";

import { Button } from "~/atoms/button";
import { AuthLayout } from "../../layouts/Auth";
import { useTranslation } from "react-i18next";

export const ActivatePasswordComplete = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <AuthLayout
      title={t(($) => $.password.activate.title)}
      description={t(($) => $.password.activate.description)}
    >
      <div className="pt-2">
        <Button onClick={() => navigate("/login")}>
          {t(($) => $.password.activate.toLogin)}
        </Button>
      </div>
    </AuthLayout>
  );
};
